import { useState, useRef, useEffect } from 'react';
import { LogOut, ChevronDown } from 'lucide-react';
import { useAuth, type User } from '../app/AuthContext';

export function UserMenu({ user }: { user: User }) {
  const [open, setOpen] = useState(false);
  const { logout } = useAuth();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handler(e: MouseEvent) {
      if (!ref.current?.contains(e.target as Node)) setOpen(false);
    }
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-2 h-9 px-3 rounded-[var(--radius-sm)] hover:bg-[var(--color-page)]"
      >
        <span className="text-sm">{user.full_name || user.username}</span>
        <ChevronDown size={14} strokeWidth={1.5} />
      </button>
      {open && (
        <div
          role="menu"
          className={[
            'absolute right-0 top-full mt-1 min-w-[180px] py-1',
            'bg-[var(--color-surface)] border border-[var(--color-border)]',
            'rounded-[var(--radius-sm)] shadow-[var(--shadow-md)] z-10',
          ].join(' ')}
        >
          <button
            role="menuitem"
            type="button"
            onClick={() => void logout()}
            className="w-full px-3 py-2 text-left text-sm hover:bg-[var(--color-page)] inline-flex items-center gap-2"
          >
            <LogOut size={14} strokeWidth={1.5} /> Выйти
          </button>
        </div>
      )}
    </div>
  );
}
